export enum FloorType{
    FLOOR="FLOOR",
    MEZZANINE= "MEZZANINE"
}


export interface Floor{
    id?: number
    floorType: FloorType
    surface : number
    floorNumber: number | null
}